import React from 'react'
import UserManagement from '../components/admin/UserManagement'

const AdminUsers: React.FC = () => {
  return <UserManagement />
}

export default AdminUsers